import { z } from 'zod';
export const agentMessageInputSchema = z.object({
    message: z.string().trim().min(1).max(8_000),
    conversationId: z.uuid().nullable().default(null),
    locale: z.enum(['fr', 'en']).default('fr'),
});
//# sourceMappingURL=agent.js.map